import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import CardProductosOne from "./CardProductosOne";
import imgI from "../assets/images/icons/arrowI.svg";
import imgD from "../assets/images/icons/arrowD.svg";

export default function ProductosOne({ productos }) {
  // Duplicamos los productos para que se vean más en el carrusel
  const duplicatedProductos = [...productos, ...productos];

  return (
    <section className="w-full bg-sidom-light dark:bg-sidom-blue overflow-hidden">
      <div className="relative container mx-auto py-10 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-8">
        <Swiper
          modules={[Navigation]}
          loop={true}
          centeredSlides={true}
          navigation={{
            prevEl: ".swiper-button-prev-custom",
            nextEl: ".swiper-button-next-custom",
          }}
          breakpoints={{
            // Móviles pequeños (320px - 479px)
            0: {
              slidesPerView: 1,
              spaceBetween: 15,
              centeredSlides: true,
            },
            // Móviles medianos (480px - 639px)
            480: {
              slidesPerView: 1,
              spaceBetween: 25,
              centeredSlides: true,
            },
            // Móviles grandes / Tablets pequeñas (640px - 767px)
            640: {
              slidesPerView: 1.3,
              spaceBetween: 25,
              centeredSlides: true,
            },
            // Tablets (768px - 899px)
            768: {
              slidesPerView: 1.5,
              spaceBetween: 25,
              centeredSlides: true,
            },
            // Tablets medianas - AJUSTE ESPECÍFICO PARA 900px
            900: {
              slidesPerView: 1.8,
              spaceBetween: 30,
              centeredSlides: true,
            },
            // Tablets grandes (1024px - 1199px)
            1024: {
              slidesPerView: 2,
              spaceBetween: 30,
              centeredSlides: true,
            },
            // Desktop pequeño (1200px - 1399px)
            1200: {
              slidesPerView: 2.5,
              spaceBetween: 35,
              centeredSlides: true,
            },
            // Desktop mediano (1400px - 1599px)
            1400: {
              slidesPerView: 3,
              spaceBetween: 40,
              centeredSlides: true,
            },
            // Desktop grande (1600px+)
            1600: {
              slidesPerView: 3.2,
              spaceBetween: 45,
              centeredSlides: true,
            },
          }}
          className="productos-swiper w-full"
        >
          {duplicatedProductos.map((producto, index) => (
            <SwiperSlide
              key={index}
              className="flex justify-center items-center"
            >
              <div className="w-full max-w-sm mx-auto">
                <CardProductosOne
                  icon={producto.logo?.url}
                  img={producto.img?.url || producto.img}
                  title={producto.titulo || producto.title}
                  description={producto.descripcion}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Flechas navegación responsive */}
        <button className="swiper-button-prev-custom absolute -left-1 top-[60%] -translate-y-1/2 z-20 p-1 lg:p-3 xl:p-3 hover:opacity-75 transition-all duration-300">
          <img src={imgI} alt="Flecha izquierda" className="w-5" />
        </button>
        <button className="swiper-button-next-custom absolute -right-1 top-[60%] -translate-y-1/2 z-20 p-1 lg:p-3 xl:p-3  hover:opacity-75 transition-all duration-300">
          <img src={imgD} alt="Flecha derecha" className="w-5" />
        </button>
      </div>
    </section>
  );
}
